import { render, staticRenderFns } from "./choiceSpecialModule.vue?vue&type=template&id=e2c50c4c&"
import script from "./choiceSpecialModule.vue?vue&type=script&lang=js&"
export * from "./choiceSpecialModule.vue?vue&type=script&lang=js&"
import style0 from "./choiceSpecialModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports